import '../styles/privacy.css';

export function PrivacyPage() {
  return (
    <div className="privacy">
      <h1>Privacy Policy</h1>
      <p className="privacy__updated">Last updated: February 22, 2026</p>

      <section>
        <h2>IO Inspector Chrome Extension</h2>
        <p>
          The IO Inspector Chrome extension is an internal tool built by and for the
          Thales Identity &amp; Access Management team. It intercepts Identity Orchestration
          workflow requests for analysis and validation, and connects to the IO Marketplace
          for browsing community-shared flows and nodes.
        </p>
      </section>

      <section>
        <h2>Data Collection</h2>
        <p>The extension collects the following data only when actively in use:</p>
        <ul>
          <li>
            <strong>Workflow request data:</strong> HTTP requests to Identity Orchestration
            endpoints are intercepted locally in the browser for real-time analysis and
            validation. This data is not transmitted externally.
          </li>
          <li>
            <strong>Issue reports:</strong> When a user voluntarily submits an issue report,
            the report may include a screenshot of the current page, recent intercepted
            requests, user-attached files, and a text description. This data is sent to
            the IO Marketplace server for review by administrators.
          </li>
          <li>
            <strong>API key:</strong> The user's marketplace API key is stored locally
            in Chrome storage to authenticate with the IO Marketplace API.
          </li>
        </ul>
      </section>

      <section>
        <h2>Data Storage</h2>
        <ul>
          <li>All intercepted request data is stored locally in the browser and is never sent to external servers unless the user explicitly submits an issue report.</li>
          <li>Issue reports are stored on the IO Marketplace server and are accessible only to administrators.</li>
          <li>The API key is stored in Chrome's local storage and is not shared with third parties.</li>
        </ul>
      </section>

      <section>
        <h2>Permissions</h2>
        <p>The extension requests the following browser permissions:</p>
        <ul>
          <li><strong>activeTab / tabs:</strong> To capture screenshots for issue reports and detect the current page URL.</li>
          <li><strong>storage:</strong> To persist the API key and user preferences.</li>
          <li><strong>scripting:</strong> To inject the request interceptor into web pages.</li>
          <li><strong>sidePanel:</strong> To display the marketplace browser in Chrome's side panel.</li>
          <li><strong>host_permissions (&lt;all_urls&gt;):</strong> To intercept workflow requests on any Identity Orchestration environment.</li>
        </ul>
      </section>

      <section>
        <h2>Third Parties</h2>
        <p>
          The extension does not share any data with third parties. All data is transmitted
          only between the browser and the IO Marketplace server operated by the Thales
          Identity &amp; Access Management team.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          For questions about this privacy policy or the IO Inspector extension,
          contact the IO Marketplace administrators.
        </p>
      </section>
    </div>
  );
}
